document.addEventListener("DOMContentLoaded", function() {
  /* Slider */
  var leftSlider = document.querySelector('.power-calculation-left');
  var rightSlider = document.querySelector('.power-calculation-right');
  if (leftSlider && rightSlider) {
    $(leftSlider).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      fade: true,
      asNavFor: '.power-calculation-right',
      adaptiveHeight: true
    });
    $(rightSlider).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      asNavFor: '.power-calculation-left',
      adaptiveHeight: true
    });
  }

  /* Tabs */
  var tabs = document.querySelectorAll('.power-calculation-tab');
  tabs.forEach(function(tab, index) {
    tab.addEventListener('click', function() {
      if (leftSlider) $(leftSlider).slick('slickGoTo', index);
      if (rightSlider) $(rightSlider).slick('slickGoTo', index);
      tabs.forEach(function(t) {
        t.classList.remove('active');
      });
      tab.classList.add('active');
    });
  });

  /* Active tab on slide change */
  if (rightSlider) {
    $(rightSlider).on('afterChange', function(event, slick, currentSlide) {
      tabs.forEach(function(t) {
        t.classList.remove('active');
      });
      if (tabs[currentSlide]) {
        tabs[currentSlide].classList.add('active');
      }
    });
  }
});

document.addEventListener("click", function (e) {
  const closeBtn = e.target.closest(".port-close");
  if (!closeBtn) return;

  const item = closeBtn.closest(".port-section__item");
  if (!item) return;

  const index = item.dataset.index;

  item.classList.remove("active");

  const dot = document.querySelector('.port-section__dot[data-index="' + index + '"]');
  if (dot) dot.classList.remove("active");
});